// extracted by mini-css-extract-plugin
export default {"container":"m9_BoM28iRiSiCFzU5Uu","title":"FEH4oMx6LwykvuMJbJDU"};